<template>
  <li class="text-black font-semibold text-sm px-3 py-2 rounded-lg m-1" :class="liClases" @click.stop="clicked">
    <span class="flex items-center" :class="spanClasses">
      <feather-icon v-if="icon" :icon="icon" svgClasses="h-6 w-6" class="mr-2" />
      <span>{{title}}</span>
    </span>
  </li>
</template>
<script>

// import { midnight, isPast, daysFromDate } from '@/helpers/date'
export default {
  components: {
  },
  props: ['icon', 'title', 'disabled', 'color'],

  computed: {
    liClases () {
      if (this.disabled) {
        return `disabled opacity-50 ${this.textColor}`
      } else {
        return `cursor-pointer hover:bg-grey-light hover:rounded ${this.textColor}`
      }
    },
    spanClasses () {
      if (this.disabled) {
        return 'cursor-not-allowed'
      } else {
        return ''
      }
    },
    textColor () {
      return this.color || 'text-dark'
    }
  },
  methods: {
    clicked () {
      if (!this.disabled) {
        this.$emit('contextMenuClicked')
      }
    }
  }
}
</script>

<style scoped>
</style>
